<template>
    <div class="section-bg">
        <div class="header-title">
            <div class="logo-image">
                <img src="/images/jtca_logo.png" alt="ロゴ">
            </div>
            <h1>
                急性期ケア専門士<br/>
                模擬試験申し込み確認
            </h1>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConfirmHeader"
}
</script>

<style scoped>

</style>
